import React, { useEffect, useState } from 'react';
import { Panel } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { navigate } from 'raviger';
import _ from 'lodash';

import FileForm from '../../components/Forms/FileForm/FileForm';
import Permission from '../../components/Permission/Permission';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import SideMenu from '../../components/SideMenu/SideMenu';
import PageHeader from '../../components/PageHeader/PageHeader';
import BaseList from '../../components/Lists/BaseList/BaseList';

import * as constants from '../../constants';

import { columns, sorting } from './BalanceDueListSchema';

function BalanceDueUpload(props) {
    const dispatch = useDispatch();

    const [isMounted, setIsMounted] = useState(false);

    const pagePermission = constants.PERMISSION_ACCOUNTING_BALENCEDUEUPLOAD;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const [callList, setCallList] = useState([]);


    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }
        setIsMounted(true);
    }, [hasPermission, isMounted, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    useEffect(() => {
        dispatch(breadcrumbAddRoute({ key: 'accounting', text: 'Accounting' }));
        dispatch(breadcrumbAddRoute({ key: 'balancedueupload', text: 'Balance Due Upload', path: window.location.pathname }));

        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    const cancelledHandler = () => {
        navigate('/instances');
    };

    const completedHandler = () => {
        //missing function on old compenent page. need to assure this page doesnt break.
    };

    const fileCompletedHandler = (_file, response) => {
        if (!_.isEmpty(response) && !_.isEmpty(response.outbounds)) {
            setCallList(response.outbounds);
        }
    };


    return (
        <>
            <SideMenu activeKey="accounting" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />

                {hasPermission && isMounted &&

                    <div style={{ paddingRight: '15px' }}>
                        <PageHeader title="Balance Due Upload" />
                        <Panel>
                            <Panel.Body>

                                {canEdit &&
                                    <>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <p style={{ fontWeight: 'bold' }}>NOTE: Only CSV formatted file formats are accepted.  Ensure the file contains ONLY the two following fields with one pair per row:
                                                    <code>AccountNumber</code> (formatted as text), <code>Balance</code> (formatted as decimal number with no formatting).<br />
                                                    Do NOT include a header row in your file.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <FileForm
                                                    postUrl="/Accounting/Outbound/BalanceDue"
                                                    acceptedFiles="text/csv"
                                                    allowedFiletypes={['.cvs']}
                                                    maxFiles={1}
                                                    cancelled={cancelledHandler}
                                                    fileCompleted={(file, response) => fileCompletedHandler(file, response)}
                                                    completed={completedHandler} />
                                            </div>
                                        </div>
                                    </>
                                }
                                <div className="row" style={{ paddingTop: '20px' }}>
                                    <div className="col-md-12">
                                        <BaseList
                                            compType="Call List"
                                            listData={callList}
                                            sorting={sorting}
                                            columns={columns}
                                            hideAdd={true}
                                            hideCopy={true}
                                            hidePrint={true}
                                            hideDelete={true}
                                            hideRefresh={true}
                                            hideFilter={true}
                                            hideEdit={true}
                                            permissionEdit={canEdit}
                                        />
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>
                    </div>
                }
            </div>
        </>
    );
};

export default withAuthentication(withLayout(BalanceDueUpload));